<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Recipients</ng-container>

    <ng-container dialog-process-in-progress>
        <div class="pl-3">
            <app-checkbox (ngModelChange)="selectAllRecipients($event)" [(ngModel)]="selectAll">
                <ng-container text>Select all</ng-container>
            </app-checkbox>
        </div>

        <app-report-table
            [config]="dataTableConfig"
        ></app-report-table>

        <app-simple-pagination
            (currentPageChange)="onPageChanged($event)"
            [currentPage]="currentPage"
            [pageSize]="itemsPerPage"
            [totalItemsCount]="totalItemCount"
        >
        </app-simple-pagination>
    </ng-container>

</app-dialog>
